<div
  style="position: fixed; background-color: #ffffff; min-width: 290px; max-width: calc(100% - 370px); max-height: 80%; overflow-y: auto"
  class="shadow-3 border-round p-2"
>
  <div>
    <div
      (click)="toggleAllStatus()"
      pRipple
      class="flex justify-content-center align-items-center align-content-center cursor-pointer gap-2"
      style="min-height: 35px; padding-top: 10px;"
    >
      <i aria-hidden="true" class="asset-status" [ngStyle]="{backgroundColor: mapIconsService.DEFAULT_NEW_ICON_MAIN_COLOR}"></i>

      <p *ngIf="toggleActivateStatus" class="flex align-items-center h-full mb-0">
        {{ 'misc.toggleDeactivate' | transloco }}
      </p>
      <p *ngIf="!toggleActivateStatus" class="flex align-items-center h-full mb-0">
        {{ 'misc.toggleActivate' | transloco }}
      </p>
    </div>
    <div class="grid m-3">
      <div
        *ngFor="let status of possibleStatus"
        [style.opacity]="statusSet.has(status) ? 1 : 0.4"
        (click)="toggleStatus(status)"
        pRipple
        class="col-12 md:col-6 lg:col-4 xl:col-2 cursor-pointer"
        style="height: 57px; min-width: 150px"
      >
        <div class="flex align-items-center w-full asset-card p-2 gap-1 h-full"  style="height: 57px;">
          <div class="flex align-items-center justify-content-center"  style="width: 35px">
            <i aria-hidden="true" class="asset-status" [ngStyle]="{backgroundColor: assetRepresentationsService.getColorFromLoadedPreferences(status) ?? mapIconsService.getNewDefaultIconMainColor()}"></i>
          </div>
          <p style="white-space: normal; overflow: hidden; text-overflow: ellipsis; word-wrap: break-word"> Estado: {{'misc.representation.' + status.toLowerCase() | transloco}}</p>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div
      (click)="toggleAllRepresentations()"
      pRipple
      class="flex justify-content-center cursor-pointer"
      style="min-height: 35px; padding-top: 10px;"
    >
      <img *ngIf="mapIconsService.getNewDefaultIcon()"
        [src]="'data:image/png;base64,' + mapIconsService.getNewDefaultIcon()"
        width="30"
        height="30"
        alt="Icon"
      >
      <p *ngIf="toggleActivate" class="mb-0 mt-1 ml-2">
        {{ 'misc.toggleDeactivate' | transloco }}
      </p>
      <p *ngIf="!toggleActivate" class="mb-0 mt-1 ml-2">
        {{ 'misc.toggleActivate' | transloco }}
      </p>
    </div>
    <div class="grid m-3">
      <div
        *ngFor="let representation of uniqueMapAssetRepresentations"
        [style.opacity]="representationVisibility.get(representation.name) ? 1 : 0.4"
        (click)="toggleRepresentation(representation.name)"
        pRipple
        class="col-12 md:col-6 lg:col-4 xl:col-2 cursor-pointer"
        style="min-height: 35px; min-width: 150px"
      >
        <div class="flex align-items-center w-full asset-card p-2 gap-1 h-full">
          <div style="width: 35px">
            <img
              [src]="'data:image/png;base64,' + (representation.icon ?? mapIconsService.getIcon(representation.getIdentifier()) ?? mapIconsService.getNewDefaultIcon())"
              width="30"
              height="30"
              alt="Icon"
            >
          </div>
          <p style="white-space: normal; overflow: hidden; text-overflow: ellipsis; word-wrap: break-word">{{ representation.name }}</p>
        </div>
      </div>
    </div>
  </div>

</div>
